var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "cargo-dialog",
    {
      attrs: {
        id: "app",
        "close-on-click-modal": false,
        visible: _vm.visible,
        title: _vm.title,
        "append-to-body": "",
        width: "1160px",
        top: "5vh"
      },
      on: { close: _vm.cancel }
    },
    [
      _c("search-item", {
        ref: "searchItem",
        attrs: {
          "show-more-scheme": false,
          "show-simple": false,
          "expand-adv": true,
          "col-settings": { span: 12 },
          "search-item-code": _vm.$t("SeaExport.AddBillCharge"),
          "config-module": _vm.searchItemModule,
          "auto-init": _vm.searchItemAutoInit,
          "custom-search-items": _vm.customSearchItems,
          "append-to-body": ""
        },
        on: { advSearchItemCallBack: _vm.fetchData }
      }),
      _c(
        "div",
        {
          staticClass: "section grid-wrapper",
          staticStyle: { display: "flex", "flex-grow": "1" }
        },
        [
          _c("cargo-ag-grid", {
            style: { width: "100%", height: "100%", "flex-grow": 1 },
            attrs: {
              "config-module": "512100",
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "grid-params": _vm.gridParams,
              "row-data": _vm.rowData
            },
            on: {
              "update:gridParams": function($event) {
                _vm.gridParams = $event
              },
              "update:grid-params": function($event) {
                _vm.gridParams = $event
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pagination-wrapper", attrs: { id: "footer-wrapper" } },
        [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "flex-end",
                "flex-wrap": "wrap",
                "margin-top": "10px"
              }
            },
            [
              _vm.selectedCount > 0
                ? _c("div", [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("Message.Choose")) +
                          " ： " +
                          _vm._s(_vm.selectedCount)
                      )
                    ])
                  ])
                : _vm._e()
            ]
          ),
          _c("cargo-pagination", {
            attrs: {
              "config-module": "512100",
              total: _vm.searchConditions.total,
              page: _vm.searchConditions.pageNum,
              limit: _vm.searchConditions.pageSize
            },
            on: {
              "update:page": function($event) {
                return _vm.$set(_vm.searchConditions, "pageNum", $event)
              },
              "update:limit": function($event) {
                return _vm.$set(_vm.searchConditions, "pageSize", $event)
              },
              pagination: _vm.fetchDataByPage
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { no: "enterEvent", type: "primary", size: "mini" },
              on: { click: _vm.enterEvent }
            },
            [_vm._v(_vm._s(_vm.$t("Billing.billingView_Determine")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "cancel", size: "mini" },
              on: { click: _vm.cancel }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }